(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nh-campaign-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-nh-tab]');
    if (!tab) return;
    var nav = tab.closest('[data-nh-campaign-tabs]');
    if (!nav) return;
    e.preventDefault();
    if (tab.classList.contains('nh-campaign-tabs__item--active')) return;

    var url = tab.getAttribute('href');
    if (!url) return;

    var content = document.querySelector('#CollectionAjaxContent');
    if (!content) { window.location.href = url; return; }

    var current = nav.querySelector('.nh-campaign-tabs__item--active');
    if (current) {
      current.classList.remove('nh-campaign-tabs__item--active');
      current.removeAttribute('aria-current');
    }
    tab.classList.add('nh-campaign-tabs__item--active');
    tab.setAttribute('aria-current', 'page');
    content.setAttribute('aria-busy', 'true');

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CollectionAjaxContent');
        if (!fresh) {
          window.location.href = url;
          return;
        }
        fresh.querySelectorAll('[data-aos]').forEach(function (el) {
          el.removeAttribute('data-aos');
          el.removeAttribute('data-aos-offset');
        });
        fresh.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.setAttribute('loading', 'eager');
        });
        content.innerHTML = fresh.innerHTML;
        content.removeAttribute('aria-busy');
        history.pushState(null, '', url);
        if (typeof theme !== 'undefined') {
          if (theme.sections) theme.sections.reinit('collection-grid');
          if (theme.MultiProductCart) theme.MultiProductCart.init();
          if (theme.initQuickShop) theme.initQuickShop();
        }
      })
      .catch(function () {
        content.removeAttribute('aria-busy');
        window.location.href = url;
      });
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nh-warteliste-email"] && !Shopify.designMode) return;
  try {
    function nhWlShowError(form, msg) {
    var errorEl = form.parentElement.querySelector('[data-nh-wl-error]');
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function nhWlClearError(form) {
    var errorEl = form.parentElement.querySelector('[data-nh-wl-error]');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function nhWlSetLoading(form, isLoading) {
    var submitBtn = form.querySelector('[data-nh-wl-submit]');
    var submitLabel = form.querySelector('[data-nh-wl-submit-label]');
    if (!submitBtn) return;
    if (isLoading && !submitBtn.dataset.nhWlDefaultLabel && submitLabel) {
      submitBtn.dataset.nhWlDefaultLabel = submitLabel.textContent;
    }
    submitBtn.disabled = isLoading;
    if (submitLabel) {
      submitLabel.textContent = isLoading
        ? form.dataset.msgLoading || ''
        : submitBtn.dataset.nhWlDefaultLabel || submitLabel.textContent;
    }
  }

  document.addEventListener('nh:klaviyo-subscribe:loading', function (event) {
    var form = event.target.matches('[data-nh-wl-form]') ? event.target : null;
    if (!form) return;
    if (event.detail.isLoading) nhWlClearError(form);
    nhWlSetLoading(form, event.detail.isLoading);
  });

  document.addEventListener('nh:klaviyo-subscribe:error', function (event) {
    var form = event.target.matches('[data-nh-wl-form]') ? event.target : null;
    if (!form) return;

    const messages = {
      invalid: form.dataset.msgInvalid,
      config: form.dataset.msgConfig,
      request: form.dataset.msgError,
      connection: form.dataset.msgConnection
    };
    nhWlShowError(form, event.detail.detail || messages[event.detail.type] || '');
  });

  document.addEventListener('nh:klaviyo-subscribe:success', function (event) {
    var form = event.target.matches('[data-nh-wl-form]') ? event.target : null;
    if (!form) return;

    var card = form.closest('[data-nh-wl-card]');
    var wrap = card ? card.querySelector('[data-nh-wl-form-wrap]') : null;
    var success = card ? card.querySelector('[data-nh-wl-success]') : null;
    form.reset();
    nhWlClearError(form);
    if (wrap) wrap.hidden = true;
    if (success) success.hidden = false;
  });
  } catch(e) { console.error(e); }
})();

})();
